import React, { useState } from 'react';
import { ArrowUpRight } from 'lucide-react';
import { programs, brand } from '../../mock';

const Programs = () => {
  const [active, setActive] = useState(programs[0].id);
  const current = programs.find((p) => p.id === active);

  return (
    <section id="programs" className="py-20 lg:py-28 bg-[var(--brand-cream-2)]">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
          <div className="max-w-2xl">
            <div className="text-xs uppercase tracking-[0.24em] text-[var(--brand-gold)] mb-4">Our Clinical Programs</div>
            <h2 className="font-serif text-4xl lg:text-6xl text-green tracking-tight leading-[1.04]">
              Six programs. <em className="italic">One integrated</em> approach.
            </h2>
          </div>
          <p className="max-w-md text-[var(--brand-mute)] text-lg">
            Every program is delivered by a multidisciplinary team — doctors, dietitians and coaches — grounded in the latest research.
          </p>
        </div>

        <div className="mt-14 grid lg:grid-cols-12 gap-8">
          <div className="lg:col-span-5 space-y-2">
            {programs.map((p) => {
              const isActive = p.id === active;
              return (
                <button
                  key={p.id}
                  onClick={() => setActive(p.id)}
                  className={`w-full text-left rounded-2xl p-5 border transition-all duration-300 flex items-center justify-between gap-4 ${
                    isActive
                      ? 'bg-[var(--brand-green)] text-[var(--brand-cream)] border-[var(--brand-green)]'
                      : 'bg-[var(--brand-cream)] text-green border-[rgba(31,58,46,0.08)] hover:border-[rgba(31,58,46,0.25)]'
                  }`}
                >
                  <div className="flex items-center gap-4">
                    <span
                      className={`font-serif text-xl w-10 shrink-0 ${
                        isActive ? 'text-[var(--brand-gold-2)]' : 'text-[var(--brand-gold)]'
                      }`}
                    >
                      {p.n}
                    </span>
                    <span className="font-serif text-xl lg:text-2xl leading-tight">{p.title}</span>
                  </div>
                  <ArrowUpRight
                    size={18}
                    className={`shrink-0 transition-transform duration-300 ${isActive ? 'rotate-45' : ''}`}
                  />
                </button>
              );
            })}
          </div>

          <div className="lg:col-span-7">
            <div className="sticky top-28 rounded-[28px] overflow-hidden border border-[rgba(31,58,46,0.08)] bg-[var(--brand-cream)]">
              <div className="relative aspect-[16/10] overflow-hidden">
                <img
                  key={current.image}
                  src={current.image}
                  alt={current.title}
                  className="absolute inset-0 h-full w-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[rgba(31,58,46,0.6)] via-transparent to-transparent" />
                <div className="absolute left-6 bottom-6 right-6">
                  <div className="text-xs uppercase tracking-[0.22em] text-[var(--brand-gold-2)]">Program {current.n}</div>
                  <div className="font-serif text-3xl lg:text-4xl text-[var(--brand-cream)] mt-1">{current.title}</div>
                </div>
              </div>
              <div className="p-6 lg:p-8">
                <div className="text-xs uppercase tracking-[0.22em] text-[var(--brand-gold)] mb-3">{current.tag} treated</div>
                <div className="flex flex-wrap gap-2">
                  {current.conditions.map((c) => (
                    <span
                      key={c}
                      className="text-[13px] px-3 py-1.5 rounded-full bg-[var(--brand-cream-2)] border border-[rgba(31,58,46,0.08)] text-green"
                    >
                      {c}
                    </span>
                  ))}
                </div>
                <div className="mt-6 border-t border-[rgba(31,58,46,0.08)] pt-5">
                  <div className="text-xs uppercase tracking-[0.22em] text-[var(--brand-gold)] mb-2">Focus</div>
                  <p className="text-[15px] text-[var(--brand-ink)] leading-relaxed">{current.focus}</p>
                </div>
                <a href={brand.bookingUrl} target="_blank" rel="noopener noreferrer" className="btn-primary mt-6 text-sm">Book a consultation</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Programs;
